import React, { Component } from "react";
import Dashboard from "../../../components/Dashboard/Dashboard";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : DashboardForm
Description : Componente que invoca al componente Dashboard, para creación de empleados.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Dashboard
================================================================================ */
class DashboardForm extends Component {
    render() {
        return (
            <Dashboard />
        )
    }
}

export default DashboardForm;